<template lang="html">
  <boxwrap class="user--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          @click="createPopup()"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          v-if="selected.length > 0"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          v-if="selected.length > 0"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          @click="update()"
          v-if="selected.length > 0"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(users)"
                    :checked="selectAll"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                :sort="true"
                class="no"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                :sort="true"
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
              >
                created at
              </tbl-td>

              <tbl-td
                :sort="true"
                class="login-id"
                @click.native="sort('login_id')"
                v-if="checkCol('login_id', tblSetting)"
              >
                login id
              </tbl-td>

              <tbl-td
                :sort="true"
                class="login-name"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort('login_name')"
              >
                login name
              </tbl-td>

              <tbl-td
                :sort="true"
                class="level"
                v-if="checkCol('level', tblSetting)"
                @click.native="sort('level_id')"
              >
                level
              </tbl-td>

              <tbl-td
                class="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                agent
              </tbl-td>

              <tbl-td
                :sort="true"
                class="email"
                v-if="checkCol('email', tblSetting)"
                @click.native="sort('email')"
              >
                email
              </tbl-td>

              <tbl-td
                :sort="true"
                class="phone"
                v-if="checkCol('phone', tblSetting)"
                @click.native="sort('phone')"
              >
                phone
              </tbl-td>

              <tbl-td
                class="vip"
                v-if="checkCol('vip', tblSetting)"
              >
                vip
              </tbl-td>

              <tbl-td
                class="status"
                v-if="checkCol('status', tblSetting)"
              >
                status
              </tbl-td>

              <tbl-td
                class="bank-details"
                v-if="checkCol('wallets', tblSetting)"
              >
                bank details

                <ul class="tbl-subcells col3">
                  <li class="bank-name">
                    <span>name</span>
                  </li>

                  <li class="bank-account-name">
                    <span>account name</span>
                  </li>

                  <li class="bank-number">
                    <span>number</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                class="referrer"
                v-if="checkCol('referrer', tblSetting)"
              >
                referrer
              </tbl-td>

              <tbl-td
                class="code"
                v-if="checkCol('code', tblSetting)"
              >
                code
              </tbl-td>

              <tbl-td
                class="deposit-account"
                v-if="checkCol('bank_account_name', tblSetting)"
              >
                deposit account

                <ul class="tbl-subcells col2">
                  <li class="bank-account-name">
                    <span>account name</span>
                  </li>
                  <li class="bank-number">
                    <span>account number</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                class="balance"
                v-if="checkCol('amount', tblSetting)"
              >
                balance
              </tbl-td>

              <tbl-td
                class="points"
                v-if="checkCol('point', tblSetting)"
              >
                points
              </tbl-td>

              <tbl-td
                class="total-cash-in"
                v-if="checkCol('total_cash_in', tblSetting)"
              >
                total cash in
              </tbl-td>

              <tbl-td
                class="total-cash-out"
                v-if="checkCol('total_cash_out', tblSetting)"
              >
                total cash out
              </tbl-td>

              <tbl-td
                class="total-cash-net"
                v-if="checkCol('total_cash_net', tblSetting)"
              >
                total cash net
              </tbl-td>

              <tbl-td
                class="total-bet-sports"
                v-if="checkCol('total_bet_sports', tblSetting)"
              >
                total bet sports
              </tbl-td>

              <tbl-td
                class="total-bet-virtual"
                v-if="checkCol('total_bet_virtual', tblSetting)"
              >
                total bet virtual
              </tbl-td>

              <tbl-td
                class="total-bet-mini"
                v-if="checkCol('total_bet_mini', tblSetting)"
              >
                total bet mini
              </tbl-td>

              <tbl-td
                class="total-bet-slot"
                v-if="checkCol('total_bet_slot', tblSetting)"
              >
                total bet slot
              </tbl-td>

              <tbl-td
                class="total-bet"
                v-if="checkCol('total_bet', tblSetting)"
              >
                total bet
              </tbl-td>

              <tbl-td
                class="total-win-sports"
                v-if="checkCol('total_win_sports', tblSetting)"
              >
                total win-sports
              </tbl-td>

              <tbl-td
                class="total-win-virtual"
                v-if="checkCol('total_win_virtual', tblSetting)"
              >
                total win-virtual
              </tbl-td>

              <tbl-td
                class="total-win-mini"
                v-if="checkCol('total_win_mini', tblSetting)"
              >
                total win-mini
              </tbl-td>

              <tbl-td
                class="total-win-slot"
                v-if="checkCol('total_win_slot', tblSetting)"
              >
                total win-slot
              </tbl-td>

              <tbl-td
                class="total-win"
                v-if="checkCol('total_win', tblSetting)"
              >
                total win
              </tbl-td>

              <tbl-td
                :sort="true"
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                :sort="true"
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
              >
                deleted at
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="user in users"
              :key="user.id"
              :class="{'is-deleted': user.deleted_at}"
            >
              <tbl-td class="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="user.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ user.id }}
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ user.created_at | date }}
              </tbl-td>

              <tbl-td
                class="login-id"
                @click.native="openUser(user.id)"
                v-if="checkCol('login_id', tblSetting)"
              >
                {{ user.login_id }}
              </tbl-td>

              <tbl-td
                class="login-name"
                v-if="checkCol('login_name', tblSetting)"
              >
                {{ user.login_name }}
              </tbl-td>

              <tbl-td
                class="level"
                v-if="checkCol('level', tblSetting)"
              >
                <select-list
                  :title="user.level.name"
                  :withReset="true"
                  v-model="user.level_id"
                  v-if="checkPermission"
                >
                  <select-option
                    v-for="level in levels"
                    :key="level.id"
                    :value="level.id"
                    :name="level.name"
                    @click.native="setSelected(user.id, 'level_id')"
                  >
                    {{ level.name }}
                  </select-option>
                </select-list>
                <span v-else>{{ user.level.name }}</span>
              </tbl-td>

              <tbl-td
                class="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                {{ user.code.agent_id }}
              </tbl-td>

              <tbl-td
                class="email"
                v-if="checkCol('email', tblSetting)"
              >
                {{ user.email }}
              </tbl-td>

              <tbl-td
                class="phone"
                v-if="checkCol('phone', tblSetting)"
              >
                {{ user.phone }}
              </tbl-td>

              <tbl-td
                class="vip"
                v-if="checkCol('vip', tblSetting)"
              >
                <select-list
                  :title="user.vip.name"
                  :withReset="true"
                  v-model="user.vip_id"
                  v-if="checkPermission"
                >
                  <select-option
                    v-for="vip in vipList"
                    :value="vip.id"
                    :key="vip.id"
                    :name="vip.name"
                    @click.native="setSelected(user.id, 'vip_id')"
                  >
                    {{ vip.name }}
                    {{ vip.id }}
                  </select-option>
                </select-list>
                <span v-else>{{ user.vip.name }}</span>
              </tbl-td>

              <tbl-td
                class="status"
                v-if="checkCol('status', tblSetting)"
              >
                <select-list
                  :title="user.status | status"
                  :withReset="true"
                  v-model="user.status"
                  v-if="!user.deleted_at && checkPermission"
                >
                  <select-option
                    v-for="(stat, x) in stats"
                    :key="x"
                    :value="stat"
                    :name="stat | status"
                    @click.native="setSelected(user.id, 'status')"
                  >
                    {{ stat | status }}
                  </select-option>
                </select-list>
                <span v-else> {{ (!user.deleted_at ? user.status : 'd') | status }}</span>
              </tbl-td>

              <tbl-td
                class="bank-details"
                v-if="checkCol('wallets', tblSetting)"
              >
                <ul
                  class="tbl-subcells col3"
                  v-for="(wallet, i) in user.wallets"
                  v-if="wallet.is_main"
                  :key="i"
                >
                  <li class="bank-name">
                    <span>{{ wallet.bank_name }}</span>
                  </li>

                  <li class="bank-account-name">
                    <span>{{ wallet.bank_account_name }}</span>
                  </li>

                  <li class="bank-number">
                    <span>{{ wallet.bank_number }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                class="referrer"
                v-if="checkCol('referrer', tblSetting)"
              >
                <template v-if="user.referrer">
                  {{ user.referrer.referrer_name }}
                </template>

                <template v-if="!user.referrer">-</template>
              </tbl-td>

              <tbl-td
                class="code"
                v-if="checkCol('code', tblSetting)"
              >
                {{ user.code.code }}
              </tbl-td>

              <tbl-td
                class="deposit-account"
                v-if="checkCol('bank_account_name', tblSetting)"
              >
                <ul class="tbl-subcells col2">
                  <li class="bank-account-name">
                    <span>{{ user.code.bank_account_name }}</span>
                  </li>

                  <li class="bank-number">
                    <span>{{ user.code.bank_number }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                class="balance"
                v-if="checkCol('amount', tblSetting)"
              >
                {{ user.amount | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="points"
                v-if="checkCol('point', tblSetting)"
              >
                {{ user.point | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-cash-in"
                v-if="checkCol('total_cash_in', tblSetting)"
              >
                {{ user.total_cash_in | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-cash-out"
                v-if="checkCol('total_cash_out', tblSetting)"
              >
                {{ user.total_cash_out | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-cash-net"
                v-if="checkCol('total_cash_net', tblSetting)"
              >
                {{ user.total_cash_in | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-bet-sports"
                v-if="checkCol('total_bet_sports', tblSetting)"
              >
                {{ user.total_bet_sports | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-bet-virtual"
                v-if="checkCol('total_bet_virtual', tblSetting)"
              >
                {{ user.total_bet_virtual | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-bet-mini"
                v-if="checkCol('total_bet_mini', tblSetting)"
              >
                {{ user.total_bet_mini | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-bet-slot"
                v-if="checkCol('total_bet_slot', tblSetting)"
              >
                {{ user.total_bet_slot | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-bet"
                v-if="checkCol('total_bet', tblSetting)"
              >
                {{ user.total_bet | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-win-sports"
                v-if="checkCol('total_win_sports', tblSetting)"
              >
                {{ user.total_win_sports | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-win-virtual"
                v-if="checkCol('total_win_virtual', tblSetting)"
              >
                {{ user.total_win_virtual | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-win-mini"
                v-if="checkCol('total_win_mini', tblSetting)"
              >
                {{ user.total_win_mini | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-win-slot"
                v-if="checkCol('total_win_slot', tblSetting)"
              >
                {{ user.total_win_slot | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="total-win"
                v-if="checkCol('total_win', tblSetting)"
              >
                {{ user.total_win | FormatAmount }}
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ user.updated_at | date }}
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ user.deleted_at | date }}
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="uCount"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-user"
      title="create user"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-head">
          <div class="form-lbl"><span>user count</span></div>
          <div class="form-data">
            <div class="input-wrap">
              <input v-model.number="count" />
            </div>
          </div>
        </div>

        <div
          class="form-con"
          v-for="(user, x) in manualUsers"
          :key="x"
        >
          <div class="form-items">
            <div class="form-lbl"><span>login id</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_id')}"
              >
                <input placeholder="login id" v-model="user.login_id" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>login name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_name')}"
              >
                <input placeholder="login name" v-model="user.login_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'password')}"
              >
                <input placeholder="password" v-model="user.password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>email</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'email')}"
              >
                <input placeholder="email" v-model="user.email" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>phone</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'phone')}"
              >
                <input placeholder="phone" v-model="user.phone" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_account_name')}"
              >
                <input placeholder="bank account name" v-model="user.bank_account_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank number</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_number')}"
              >
                <input placeholder="bank number" v-model="user.bank_number" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_password')}"
              >
                <input placeholder="bank password" v-model="user.bank_password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="form-data">
              <select-list
                :title="banks[0].name"
                :withReset="true"
                v-model="user.bank_id"
              >
                <select-option
                  :value="bank.id"
                  :name="bank.id"
                  v-for="(bank, e) in banks"
                  :key="e"
                >
                  {{ bank.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>currency</span></div>
            <div class="form-data">
              <select-list
                :title="'USD'"
                :withReset="true"
                v-model="user.currency_id"
              >
                <select-option
                  value="1"
                  name="USD"
                >
                  USD
                </select-option>
                <select-option
                  value="2"
                  name="JPY"
                >
                  JPY
                </select-option>
                <select-option
                  value="2"
                  name="KRW"
                >
                  KRW
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//= mixins
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import '@/components/base/table/Table'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'users',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList
  },

  filters: {
    FormatAmount,

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    },

    formatVip (vip) {
      let v = ''

      switch (vip) {
        case 1:
          v = 'normal'
          break
        case 2:
          v = 'vip'
          break
        case 3:
          v = 'vvip'
          break
      }

      return v
    },

    formatLevel (level) {
      return 'lvl.' + level
    }
  },

  mixins: [
    swal,
    checkAll
  ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc'
      },
      this.$route.query
    )

    for (const key in params) {
      if (params.hasOwnProperty(key) && !isNaN(parseFloat(params[key]))) {
        params[key] = parseFloat(params[key])
      }
    }

    return {
      params,

      status: 'all',
      stats: ['C', 'W', 'P', 'R', 'B'],

      showCreate: false,
      showTblSettings: false,

      count: 1,

      manualUsers: [],
      selected: [],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      users: [],

      filterBy: [
        {
          value: 'id',
          display: 'id num'
        },

        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'name'
        },

        {
          value: 'email',
          display: 'email'
        },

        {
          value: 'status',
          display: 'status'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'test_user_list',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'created at ',
          value: 'created_at'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'email',
          value: 'email'
        },
        {
          display: 'phone',
          value: 'phone'
        },
        {
          display: 'vip',
          value: 'vip'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'wallets',
          value: 'wallets'
        },
        {
          display: 'referrer',
          value: 'referrer'
        },
        {
          display: 'code',
          value: 'code'
        },
        {
          display: 'bank details',
          value: 'bank_account_name'
        },
        {
          display: 'balance',
          value: 'amount'
        },
        {
          display: 'point',
          value: 'point'
        },
        {
          display: 'total cash in ',
          value: 'total_cash_in'
        },
        {
          display: 'total cash out ',
          value: 'total_cash_out'
        },
        {
          display: 'total cash net ',
          value: 'total_cash_net'
        },
        {
          display: 'total bet virtual ',
          value: 'total_bet_virtual'
        },
        {
          display: 'total bet mini ',
          value: 'total_bet_mini'
        },
        {
          display: 'total bet slot ',
          value: 'total_bet_slot'
        },
        {
          display: 'total bet ',
          value: 'total_bet'
        },
        {
          display: 'total win sports ',
          value: 'total_win_sports'
        },
        {
          display: 'total win virtual ',
          value: 'total_win_virtual'
        },
        {
          display: 'total win mini ',
          value: 'total_win_mini'
        },
        {
          display: 'total win slot ',
          value: 'total_win_slot'
        },
        {
          display: 'total win ',
          value: 'total_win'
        },
        {
          display: 'updated at ',
          value: 'updated_at'
        },
        {
          display: 'deleted at ',
          value: 'deleted_at'
        }
      ],

      selectAll: false,

      validation: []
    }
  },

  computed: {
    ...mapState('test-user', { allUsers: 'users', uCount: 'count' }),
    ...mapState('bank', ['banks']),
    ...mapState('vip', ['vipList']),
    ...mapState('level', ['levels']),
    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    },

    count () {
      this.createPopup()
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.params = this.generate(this.params)
    this.search()
    await this.getBanks({ status: 'active' })
    await this.getVips()
    await this.getLevels()
  },

  methods: {
    ...mapActions('test-user', ['getCount']),
    ...mapActions('test-user', {
      patch: 'update',
      getUsers: 'get',
      createUser: 'create',
      deleteUser: 'delete'
    }),
    ...mapActions('bank', { getBanks: 'get' }),
    ...mapActions('vip', { getVips: 'get' }),
    ...mapActions('level', { getLevels: 'get' }),

    async trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    }, // trigger

    async search (query) {
      this.params = query || this.params

      this.status = this.$route.params.status

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getUsers({
        status: this.status,
        params: this.params
      })

      this.users = JSON.parse(JSON.stringify(this.allUsers))

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.users.length) {
        this.isEmpty = true
      }

      await this.getCount({
        status: this.status,
        params: this.params
      })
    }, // search

    createPopup () {
      this.showCreate = true

      this.manualUsers = []
      for (var x = 0; x < this.count; x++) {
        this.manualUsers.push({
          login_id: '',
          login_name: '',
          email: '',
          phone: '',
          password: '',
          bank_account_name: '',
          bank_number: '',
          bank_password: '',
          bank_id: 1,
          currency_id: 1
        })
      }
    },

    checkValidation (val, key) {
      if (this.validation.length) {
        let filter = this.validation.filter((e) => {
          return parseInt(e.index) === parseInt(val)
        })

        let find = filter.find((e) => {
          return e.value === key
        })

        return !!find
      }
      return false
    },

    async create () {
      for (var x = 0; x < this.manualUsers.length; x++) {
        for (var key in this.manualUsers[x]) {
          if (this.manualUsers[x][key] === '') {
            this.validation.push({
              index: x,
              value: key
            })
          }
        }
      }

      if (this.validation.length) {
        alert('pls check ur  inputs')
        setTimeout(() => {
          this.validation = []
        }, 3000)
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, async () => {
        try {
          await this.createUser(this.manualUsers)
          this.$alert('sucess', 'You have successfully created a new user.', {}, '', 'Sucess')

          this.showCreate = false
          await this.getUsers({ status: this.status, params: this.params })
          this.users = JSON.parse(JSON.stringify(this.allUsers))
        } catch (err) {
          this.$alert('error', 'The user created already exists.', {}, '', 'Error')
        }
      }, 'Test User')
    }, // create user

    async setSelected (id, type) {
      this.$nextTick(() => {
        let unchanged = this.allUsers.find((e) => { return e.id === id })
        let changed = this.users.find((e) => { return e.id === id })
        if (changed[type] !== unchanged[type]) {
          this.selected.push(id)
          this.selected = _.uniq(this.selected)
        } else {
          let index = this.selected.indexOf(id)
          if (index > -1) {
            this.selected.splice(index, 1)
          }
        }
      })
    },

    async update () {
      this.$alert('prompt', 'Are you sure you want to modify the following test user(s)?', {}, async () => {
        let keys = ['login_id', 'login_name', 'email', 'level_id', 'vip_id', 'status']

        this.showDataLoading = true

        let edited = this.users.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < edited.length; x++) {
          let data = {}

          for (var key in edited[x]) {
            if (keys.indexOf(key) > -1) {
              data[key] = edited[x][key]
            } // end if
          } // end for

          try {
            await this.patch({ data: data, id: edited[x].id })
          } catch (err) {

          }
        } // end for
        this.selectAll = false

        console.log(this.selecteAll)
        this.showDataLoading = false
        this.search()

        if (!this.users.length) {
          this.isEmpty = true
        }
      }, 'Modify User')
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    async deleteData () {
      this.$alert('prompt', 'Are you sure you want to delete the following test user(s)?', {}, async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.deleteUser({ uid: this.selected[x] })
        }

        this.selectAll = false
        this.search()
      }, 'Delete Test User')
    },

    async restore () {
      this.$alert('prompt', 'Are you sure you want to restore the following test user(s)?', {}, async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.patch({
            id: this.selected[x],
            data: {
              deleted_at: null
            }
          })
        }

        this.selectAll = false
        this.search()
      }, 'Restore Test User')
    },

    openUser (id) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/info`,
        '',
        `width=${1000},height=${window.innerHeight}`
      )
    },

    async getTransDetails (type, id) {
      console.log(type, id)
      window.open(
        `${process.env.VUE_APP_URL}/transfers/${type}/user/${id}`,
        '',
        `width=${1000},height=${window.innerHeight}`
      )
    }
  }
}
</script>
